<template>
<form class="meet-form" @submit.prevent="submit" @keydown="validate($event.target.name)">
    <template v-if="hasMeet && !loading">
        <p v-html="t.promoting"></p><br>
        <a class="btn btn-default" :href="pages.advert.replace('CHANGE_ME', hasMeet)">{{t.view}}</a>
        <button class="btn btn-danger" @click.prevent="deleteMeet">{{t.delete_quickie}}</button>
    </template>

    <template v-else-if="!loading">
        <div v-if="persons.length > 1" class="form-group">
            <select class="form-control" v-model="form.person">
                <option value="">{{persons[0].name}} & {{persons[1].name}}</option>
                <option v-for="person in persons" :key="person.id" :value="person.id">{{person.name}}</option>
            </select>
        </div>

        <div :class="['form-group', { 'has-error': form.errors.has('title') }]">
            <input type="text" name="title" class="form-control" v-model="form.title" :placeholder="t.title">
            <span class="help-block" v-if="form.errors.has('title')">{{ form.errors.get('title') }}</span>
        </div>

        <div :class="['form-group', { 'has-error': form.errors.has('body') }]">
            <textarea class="form-control" rows="4" name="body" :placeholder="t.message" v-model="form.body"></textarea>
            <span class="help-block" v-if="form.errors.has('body')">{{ form.errors.get('body') }}</span>
        </div>

        <transition name="meet-form-slide">
            <div v-if="!collapsed" class="meet-form-collapsible">
                <div :class="['form-group', { 'has-error': form.errors.has('location') }]">
                    <label class="control-label">{{t.location}}</label>
                    <geo-complete :t="t" v-on:geocomplete="geocomplete" v-model="form.location"></geo-complete>
                    <span class="help-block" v-if="form.errors.has('location')">{{ form.errors.get('location') }}</span>
                </div>

                <div :class="['form-group', 'meet-checkboxes', { 'has-error': form.errors.has('category') }]">
                    <check-boxes v-if="!hideProfileSeeking" :options="seekingOptions" v-model="form.category"></check-boxes>
                    <span class="help-block" v-if="form.errors.has('category')">{{ form.errors.get('category') }}</span>
                </div>

                <div class="form-group">
                    <label class="control-label">{{t.period}}</label>
                    <div>
                        <slider :options="periodSliderOptions" v-model="form.period"></slider>
                        <span class="help-block"></span>
                    </div>
                </div>

                <p class="meet-form-matches-wrapper">{{t.matches}}: {{ matches }}</p>

                <div class="form-group clearfix" v-if="showButton">
                    <input name="submit" class="btn btn-primary pull-right" type="submit" :disabled="form.errors.any()" :value="t.submit">
                </div>
            </div>
        </transition>

    </template>
    <loading v-if="loading"></loading>
</form>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Form from 'Site/js/util/form';
import CheckBoxes from 'Site/component/CheckBoxes.vue';
import GeoComplete from 'Location/component/Geocomplete.vue';
import Loading from 'Site/component/Loading.vue';
import { mapState } from 'vuex';
import Slider from 'Site/component/Slider.vue';

export default {
    name: 'MeetForm',
    components: {
        CheckBoxes,
        GeoComplete,
        Loading,
        Slider
    },
    computed: {
        collapsed() {
            return this.collapsible && !(this.form.body.length + this.form.title.length);
        },
        ...mapState({
            pages: state => state.config.pages,
            siteConfig: state => state.siteConfig,
            t: state => state.t.adverts.meet_form
        })
    },
    data() {
        return {
            form: new Form({
                body: this.meet ? this.meet.body : '',
                id: this.meet ? this.meet.advertId : null,
                latitude: this.meet ? this.meet.latitude : this.location.latitude,
                longitude: this.meet ? this.meet.longitude : this.location.longitude,
                location: this.meet ? this.meet.location : this.location.text || '',
                period: this.meet ? this.meet.remainingDuration : 24,
                person: this.meet ? this.meet.personId : '',
                category: this.meet ? this.meet.seekId : this.seeking,
                title: this.meet ? this.meet.title : '',
                user: ''
            }, {
                body: ['required'],
                location: ['required'],
                category: ['required'],
                title: ['required']
            }),
            loading: false,
            matches: 0,
            periodSliderOptions: {
                start: this.meet ? this.meet.remainingDuration : 24,
                step: 1,
                range: {
                    min: 1,
                    max: 24
                },
                connect: 'lower'
            }
        };
    },
    methods: {
        deleteMeet() {
            this.loading = true;
            ajax.delete('advert', { id: this.hasMeet }).then(() => {
                this.$store.dispatch('notify', { msg: this.t.deleted_notice });
                this.$emit('delete-meet');
            });
        },
        fetchPopulation() {
            if (this.form.longitude && this.form.latitude && this.form.category.length) {
                ajax.get('population', {
                    id: this.siteConfig.user.id,
                    seeking: this.form.category,
                    latitude: this.form.latitude,
                    longitude: this.form.longitude
                }).then((response) => {
                    this.matches = response.population;
                });
            } else {
                this.matches = 0;
            }
        },
        geocomplete({ result }) {
            this.form.latitude = result.geometry.location.lat();
            this.form.longitude = result.geometry.location.lng();
            this.form.location = result.formatted_address;
            this.validate('location');
        },
        validate(field) {
            this.form.errors.clear(field);
            this.form.validate(field);
        },
        submit() {
            let method = 'create';
            if (this.form.id) {
                method = 'update';
            }
            const form = this.form[method]('advert');
            if (form) {
                this.loading = true;
                form.then((response) => {
                    this.$emit('submit-meet', this.form.id ? this.form : response);
                    this.$store.dispatch('notify', { msg: this.t.quickie_created });
                });
            }
        }
    },
    mounted() {
        this.fetchPopulation();
        this.form.user = this.siteConfig.user.id;
        this.$on('submit', this.submit);
    },
    watch: {
        'form.category': function formCategory() {
            this.fetchPopulation();
            this.validate('category');
        },
        latitude() {
            this.fetchPopulation();
        }
    },
    props: {
        collapsible: {
            type: Boolean,
            default: false
        },
        hasMeet: {
            type: [Boolean, Number],
            default: false
        },
        hideProfileSeeking: {
            type: Boolean,
            default: false
        },
        meet: {
            type: Object
        },
        persons: {
            type: Array,
            required: true
        },
        location: {
            type: Object,
            default() {
                return {};
            }
        },
        seeking: {
            type: Array,
            default() {
                return [];
            }
        },
        seekingOptions: {
            type: Array,
            required: true
        },
        showButton: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss">
.meet-form {
    .sh-checkboxes input + label {
        width: 150px;
    }
    .meet-form-matches-wrapper {
        margin: 45px 0 10px 0 !important;
        font-weight: bold;
        text-align: center;
    }
    .slider {
        margin-left: 25px;
        margin-right: 25px;
    }
}
.meet-form-collapsible {
    transition: height .5s;
    overflow: hidden;
}
.meet-checkboxes {
    text-align: center;
}
.meet-form-slide-enter-active, .meet-form-slide-leave-active {
    height: 600px;
}
.meet-form-slide-enter, .meet-form-slide-leave-to {
    height: 0;
}
</style>
